import { render, staticRenderFns } from "./InternalTransOutTab.vue?vue&type=template&id=470f5654"
import script from "./InternalTransOutTab.vue?vue&type=script&lang=js"
export * from "./InternalTransOutTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports